import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    if (error.response?.status === 401 && !original._retry && !(original.url || "").startsWith("/auth/")) {
      original._retry = true;
      refreshing = refreshing || API.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return API(original);
      } catch {
        // session expirée
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err, fallback = "Une erreur est survenue. Veuillez réessayer.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return fallback;
}

export function fmtTime(iso, tz) {
  return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", timeZone: tz });
}

export function fmtDate(iso, tz, opts = {}) {
  return new Date(iso).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", timeZone: tz, ...opts });
}

export const STATUS_LABELS = {
  confirmed: "Confirmé",
  cancelled: "Annulé",
  completed: "Terminé",
  no_show: "Absent",
};

export const STATUS_STYLES = {
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  completed: "bg-slate-100 text-slate-700 border-slate-300",
  no_show: "bg-amber-50 text-amber-700 border-amber-200",
};

export const SOURCE_LABELS = {
  online: "En ligne",
  manual: "Manuel",
  api: "API",
};
